import { FC } from "react";

import { Tag } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { PROVIDER_NETWORK_STATUS_VALUES, PROVIDER_STATUS_VALUES, STATUS_LABELS } from "@/constants";

interface ProviderStatusTagProps {
  readonly status: string;
  readonly paymentType?: string;
}

type StatusTagType = "error-high-contrast" | "warning-high-contrast" | "success-high-contrast" | "info-high-contrast";

const STATUS_TAG_MAPPING: Record<string, StatusTagType> = {
  // Error states
  [PROVIDER_STATUS_VALUES.FAILED]: "error-high-contrast",
  [PROVIDER_STATUS_VALUES.NEEDS_APPROVAL]: "error-high-contrast",

  [PROVIDER_STATUS_VALUES.DEACTIVATED]: "info-high-contrast",

  // Warning/Progress states
  [PROVIDER_STATUS_VALUES.DRAFT]: "warning-high-contrast",
  [PROVIDER_STATUS_VALUES.PROCESSING]: "warning-high-contrast",
  [PROVIDER_STATUS_VALUES.PROGRESS]: "warning-high-contrast",
  [PROVIDER_STATUS_VALUES.PENDING]: "warning-high-contrast",
  [PROVIDER_STATUS_VALUES.REVIEW]: "warning-high-contrast",

  // Success states
  [PROVIDER_STATUS_VALUES.COMPLETED]: "success-high-contrast",
  [PROVIDER_STATUS_VALUES.ACTIVE]: "success-high-contrast",
  [PROVIDER_STATUS_VALUES.ACTIVE_ACH]: "success-high-contrast",
  [PROVIDER_STATUS_VALUES.ACTIVE_CHECK]: "success-high-contrast",
  [PROVIDER_STATUS_VALUES.PROCESSED]: "success-high-contrast",
};

const displayStatusTag = (status: string | number, defaultTag: StatusTagType = "info-high-contrast"): StatusTagType => {
  const statusString = String(status).toLowerCase();
  return STATUS_TAG_MAPPING[statusString] || defaultTag;
};

const getStatusLabel = (status: string, paymentType?: string): string => {
  if (status === PROVIDER_NETWORK_STATUS_VALUES.ACTIVE && paymentType) {
    const statusKey = `${status}_${paymentType.toLowerCase()}`;
    return STATUS_LABELS[statusKey] || status;
  }
  // grab the label (or fall back to the raw status)
  const baseLabel = STATUS_LABELS[status] || status;

  // if the key contains “ach”, replace any case‐variant in the label with “ACH”
  return /ach/i.test(status) ? baseLabel.replace(/ach/gi, "ACH") : baseLabel;
};

export const StatusTag: FC<ProviderStatusTagProps> = ({ status, paymentType }) => {
  return (
    <Tag type={displayStatusTag(status)} style={{ width: "fit-content" }}>
      <Shelf alignment="center" spacing="none">
        {getStatusLabel(status, paymentType)}
      </Shelf>
    </Tag>
  );
};
